//import Logger from '@/logger'
import Router from '@/router'

export default {

    lastRoute(state) {
        return state.routeStack && state.routeStack.length ? state.routeStack[state.routeStack.length - 1] : null
    },

    lastBackIncludedRoute(state) {
        let idx = 0
        let checkRoute

        do {
            idx++
            checkRoute = state.routeStack[state.routeStack.length - idx]
        } while (checkRoute && Router.backExcludedRoutes.includes(checkRoute.name))

        return checkRoute
    },

    lastGuestAccessibleRoute(state) {
        let idx = 0
        let checkRoute

        do {
            idx++
            checkRoute = state.routeStack[state.routeStack.length - idx]
        } while (checkRoute && Router.userForcingRoutes.includes(checkRoute.name))

        return checkRoute
    },

    lastGuestAccessibleBackIncludedRoute(state) {
        let idx = 0
        let checkRoute

        do {
            idx++
            checkRoute = state.routeStack[state.routeStack.length - idx]
        } while (checkRoute && (Router.userForcingRoutes.includes(checkRoute.name) || Router.backExcludedRoutes.includes(checkRoute.name)))

        return checkRoute
    },
}
